import React, { useMemo } from 'react';
import Grid from "@mui/material/Grid";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { getAccessToken,callPowerBI } from '../../../adalConfig';
import { useSearchParams } from "react-router-dom";
import './CSS/PowerBI.css';

const Traceability = (props) => {

    const [embedded, setEmbedded] = React.useState(null);
    const [accessToken, setAccessToken] = React.useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [report, setReport] = React.useState(null);
    var rID = searchParams.get("reportId");
    React.useEffect(() => {
        const fetchData = async () => {
            // var token = await getAccessToken();
            var result = await callPowerBI( "reports/"+rID,{});
            console.log(result);
            var reportData = result.report;
            // refresh
            // var token = await callPowerBI( "v1.0/myorg/datasets/c8273496-a5e4-4fba-87d1-a35836f74284/refreshes",{
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            //     body: JSON.stringify({
            //         notifyOption: "NoNotification",
            //     }),
            // });
            setReport(reportData);
            setAccessToken(result.token);
        }
        setReport(null);
        setAccessToken(null);
        fetchData();
    }, [searchParams.get("reportId")]);

  
    const embedConfig = {

        type: 'report', // Supported types: report, dashboard, tile, visual, and qna.
        id: rID,
        embedUrl: report ? report.embedUrl : null,
        accessToken: accessToken,
        tokenType: models.TokenType.Aad, // Use models.TokenType.Aad if you're embedding for your organization.
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false
                },
                pageNavigation: {
                    visible: false
                },
                navContentPaneEnabled: false
            },
        }
    }
    var mapEV = new Map([
        ['loaded', function () { console.log('Report loaded'); }],
        ['rendered', function () { console.log('Report rendered'); }],
        ['error', function (event) { console.log(event.detail); }],
        ['visualClicked', () => console.log('visual clicked')],
        ['pageChanged', (event) => console.log(event)],
    ])
    const eventHandlers = mapEV
    
    return <div>
            {accessToken&&report ? <PowerBIEmbed
                embedConfig={embedConfig}
                eventHandlers={eventHandlers}
                cssClassName={"reportContainer"}
                getEmbeddedComponent={(embeddedReport) => {
                    setEmbedded(embeddedReport);
                }}
            /> : null}
        </div>
}

export default Traceability;